export default "__VITE_ASSET__B57jbV7H__"